import React from 'react';
import { Helmet } from 'react-helmet';
import get from 'lodash/get';

import {
  WEBSITE_URL,
  RECAPTCHA_SITE_KEY,
  CALCULATOR_CSS_URL,
  CALCULATOR_JS_URL,
} from 'gatsby-env-variables';

export default (props) => {
  const {
    ogUrl,
    ogTitle,
    ogImage,
    ogType,
    servicePages = false,
    conversionPages = false,
    loadCalculator,
  } = props;

  const structuredData = props.structuredData || {};
  const creator = get(props.structuredData, 'creator') || { address: {} };
  const mainEntity = get(props.structuredData, 'mainEntity') || {};
  const structuredDataOverride = props.structuredDataOverride;
  const { _type } = structuredData;

  return (
    <Helmet>
      <html lang="en" />
      <title>{props.metaTitle}</title>
      <meta name="description" content={props.metaDescription} />
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogType && <meta property="og:type" content={ogType} />}
      {loadCalculator && <link href={CALCULATOR_CSS_URL} rel="stylesheet" />}
      {loadCalculator && <script defer src={CALCULATOR_JS_URL}></script>}
      {!conversionPages && (
        <script type="application/ld+json">
          {structuredDataOverride
            ? structuredDataOverride
            : `{
              "@type": "${_type}",
              "creator": {
                "name": "${creator.name}",
                "@type": "${creator._type}",
                "sameAs": "${creator.sameAs}",
                "address": {
                  "@type": "${creator.address._type}",
                  "postalCode": "${creator.address.postalCode}",
                  "streetAddress": "${creator.address.streetAddress}",
                  "addressCountry": "${creator.address.addressCountry}",
                  "addressLocality": "${creator.address.addressLocality}"
                },
                "telephone": "${creator.telephone}"
              },
              "mainEntity": {
                "url": "${mainEntity.url}",
                "@type": "${mainEntity._type}",
                "abstract": "${mainEntity.abstract}",
                "inLanguage": "${mainEntity.inLanguage}"
              }
            }`
          }
        </script>
      )}
      <link rel="canonical" href={props.canonicalLink ? `${WEBSITE_URL}/${props.canonicalLink}` : `${WEBSITE_URL}/`} />
      <link rel="apple-touch-icon" sizes="57x57" href="/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <script>
        {`
          // Include the following lines to define the gtag() function when
          // calling this code prior to your gtag.js or Tag Manager snippet
          window.dataLayer = window.dataLayer || [];
          function gtag(){ dataLayer.push(arguments); }
          // Call the default command before gtag.js or Tag Manager runs to
          // adjust how the tags operate when they run. Modify the defaults
          // per your business requirements and prior consent granted/denied, e.g.:
          gtag('consent', 'default', {
            'ad_storage': 'denied',
            'analytics_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
          });
        `}
      </script>
      <script>
        {`
           (function (w,d,s,l,i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KZ7NQV');
        `}
      </script>

      <script data-cfasync="false" src="https://cc.cdn.civiccomputing.com/9/cookieControl-9.0.min.js" />
      <script src={`/${WEBSITE_URL.includes('localhost') ? '' : 'website-assets/'}utm.js?v=4`} type="text/javascript"/>
      <script src={`/${WEBSITE_URL.includes('localhost') ? '' : 'website-assets/'}preferences.js?v=19`} type="text/javascript"/>
      { !WEBSITE_URL.includes('localhost') && <script src='https://assets.adobedtm.com/bb77750356fd/6231d432156b/launch-EN37f99897a0f644a1bdc4fdf48dd63f84.min.js' async/> }
      { (servicePages || conversionPages) && <script src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`}></script>}
      { conversionPages && <meta name="robots" content="noindex, nofollow" /> }
    </Helmet>
  );
};
